export const missionVision = {
  mission: {
    icon: 'ri-focus-3-line',
    title: '使命',
    content: '数智赋能，让消费者更愿意买，让终端更愿意卖',
  },
  vision: {
    icon: 'ri-star-line',
    title: '愿景',
    content: '致力于成为客户最受信任的营销数字化伙伴',
  },
  values: {
    icon: 'ri-vip-diamond-line',
    title: '价值观',
    content: '专业专注 · 简单高效',
  },
};

export const founder = {
  name: '董文波',
  title: '创始人',
  description: '深圳融慧数科有限公司创始人，营销数字化专家、PMP项目管理专家，深耕信息化与数字化领域近20载，2024年提出"五位一体营销数字化"，拥有快消行业全周期数字化建设与运营实战经验。',
  quote: '快消行业的数字化转型，不是技术问题，而是业务理解与技术实现的融合问题。',
  quoteContext: '正是这一理念，驱动融慧数科始终以"业务价值"而非"技术炫耀"为服务核心。',
};

export const advantages = [
  {
    num: '01',
    title: '实战派操盘手',
    subtitle: '做过，并且做成过',
    desc: '亲自跑过百亿级企业的营销数字化全链路，趟过坑、避过雷，知道哪里走得通、哪里要绕开。客户买的不是功能清单，是**真正做成过这件事的经验**。',
  },
  {
    num: '02',
    title: '甲方视角做方案',
    subtitle: '做过的才懂怎么说',
    desc: '创始团队多年快消行业甲方经验，做过业务、扛过KPI，给的是带着一线执行经验做出来的营销数字化方案，不是功能堆砌。',
  },
  {
    num: '03',
    title: '行业深耕，见过的够多',
    subtitle: '快速定位问题本质',
    desc: '服务多家头部品牌，覆盖食品饮料、调味品、啤酒等多个赛道，见过的渠道场景够多，不拿PPT模板一个个试，直接定位解法。',
  },
];

export const honors = [
  {
    title: 'CMMI 3级认证',
    image: '/images/honor-cmmi3.jpg',
    description: '软件能力成熟度模型集成三级认证',
  },
  {
    title: 'ISO 20000认证',
    image: '/images/honor-iso20000.jpg',
    description: '信息技术服务管理体系认证',
  },
  {
    title: 'ISO 27001认证',
    image: '/images/honor-iso27001.jpg',
    description: '信息安全管理体系认证',
  },
  {
    title: '等保三级认证',
    image: '/images/honor-dengbao3.jpg',
    description: '信息系统安全等级保护三级',
  },
  {
    title: '中国软件产品认证',
    image: '/images/honor-software-product.jpg',
    description: '软件产品登记与评估认证',
  },
  {
    title: '中国软件企业认证',
    image: '/images/honor-software-enterprise.jpg',
    description: '软件企业资质认定',
  },
];

export const softwareProducts = [
  {
    title: '慧畅销bC一体化系统',
    image: '/images/product-bc-integration.jpg',
  },
  {
    title: '慧畅销SFA系统',
    image: '/images/product-sfa.jpg',
  },
  {
    title: '慧畅销推广管理系统',
    image: '/images/product-promotion.jpg',
  },
  {
    title: '慧畅销消费者互动系统',
    image: '/images/product-consumer-interaction.jpg',
  },
  {
    title: '慧畅销终端门店系统',
    image: '/images/product-terminal-store.jpg',
  },
  {
    title: '五码合一数据关联系统',
    image: '/images/product-five-codes.jpg',
  },
];

export const companyGallery = [
  {
    src: '/images/about-gallery-1.jpg',
    alt: '团队风采',
    caption: '融慧数科团队',
  },
  {
    src: '/images/about-gallery-2.jpg',
    alt: '团队风采',
    caption: '项目协作',
  },
  {
    src: '/images/about-gallery-3.jpg',
    alt: '团队风采',
    caption: '团建活动',
  },
  {
    src: '/images/about-gallery-4.jpg',
    alt: '企业环境',
    caption: '办公环境',
  },
  {
    src: '/images/about-gallery-5.jpg',
    alt: '办公场景',
    caption: '专注办公',
  },
  {
    src: '/images/about-gallery-6.jpg',
    alt: '团队风采',
    caption: '团队合影',
  },
];